import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { FormOfPaymentTypeSearch } from "src/app/core/models/form-of-payment-model";
import { FormOfPaymentTypeReferenceService } from "src/app/core/services/system-services/form-of-payment-type-reference.service";
import { FormOfPaymentTypeSearchCriteria } from "..";
import { tap } from "rxjs/operators";
import { StatusReferenceModel } from "src/app/core/models/reference-model/reference-general-model";
import { StatusReferenceService } from "src/app/core/services/system-services";


@Injectable({
    providedIn: 'root'
})
export class FormOfPaymentTypeSearchService {

    private _criteria$ = new BehaviorSubject<Map<string, FormOfPaymentTypeSearchCriteria>>(new Map())
    private _formOfPaymentTypes$ = new BehaviorSubject<FormOfPaymentTypeSearch[]>([])
    private _statusReferenceModels$ = new BehaviorSubject<StatusReferenceModel[]>([])
    private _callSearch$ = new BehaviorSubject<boolean>(false)
    private _refresh$ = new Subject()

    get criteria$() {
        return this._criteria$.asObservable()
    }
    get formOfPaymentTypes$() {
        return this._formOfPaymentTypes$.asObservable()
    }
    get statusReferenceModels$() {
        return this._statusReferenceModels$.asObservable()
    }
    get callSearch$() {
        return this._callSearch$.asObservable()
    }
    get refresh$() {
        return this._refresh$.asObservable()
    }

    constructor(private formOfPaymentTypeReferenceService: FormOfPaymentTypeReferenceService,
        private statusReferenceService: StatusReferenceService,) {
    }

    getFormOfPaymentTypesSearch(criteria: FormOfPaymentTypeSearchCriteria): Observable<FormOfPaymentTypeSearch[]> {
        return this.formOfPaymentTypeReferenceService.search(criteria.statusCode ?? '', criteria.formOfPaymentTypeNameWildcard ?? '', criteria.formOfPaymentTypeCode ?? '')
            .pipe(
                tap(response => this._formOfPaymentTypes$.next(response))
            )
    }

    updateStatusCode(formOfPaymentTypeCode: string, statusCode: string): Observable<never> {
        return this.formOfPaymentTypeReferenceService.updateStatusCode(formOfPaymentTypeCode, statusCode)
    }

    loadStatusReference(): Observable<StatusReferenceModel[]> {
        return this.statusReferenceService.getAll().pipe(
            tap(response => this._statusReferenceModels$.next(response))
        )
    }

    clearSearch() {
        this._formOfPaymentTypes$.next([])
    }
    callSearch() {
        this._callSearch$.next(true)
    }

    refresh() {
        this._refresh$.next()
    }

    saveCriteria(tabId: string, criteria: FormOfPaymentTypeSearchCriteria) {
        const dataMap = this._criteria$.getValue()
        dataMap.set(tabId, { ...criteria })
        this._criteria$.next(dataMap)
    }

}